<!-- 一般ユーザー　パスワード忘れた方-->
<style src="@/assets/css/login_parts.css" type="text/css" media="all" scoped></style>
<style src="@/assets/css/common_parts_input.css" type="text/css" media="all" scoped></style>
<style　scoped>

</style>
<template>
	<!-- ▼ contents -->
	<div id="login" v-bind:style="getStyle">
		<!-- ▼ header  -->
		<section id="loginHeader">
			<h2>WEB健診予約システム</h2>
			<p>Online Reservation Service</p>
		</section>
		<!-- ▲ header END -->
		<!-- ▽  -->
			<section class="pw">
			  <h3>パスワードを再発行しました</h3>
			  <p>ご登録されたメールアドレスにパスワードを送信いたしましたのでメールをご確認ください。</p>
			  <div class="btnLst"><button class="backBtn" v-on:click="onToTop">Topページへ戻る</button></div>
			</section>
			<!-- △ mainContents END -->
	</div>
</template>
<script>
  import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
  import ModalWindow from '@/components/Utility/ModalWindow'
	import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

  export default {
    // モジュール名
    name: 'CommonForgetPassword2',
    // 使用コンポーネント
    components: {
      // エラー表示コンポーネント
      'errorMessageBox': ErrorMessageBox,
      // モーダルウィンドウ表示コンポーネント
      'modalWindow': ModalWindow
    },
    // データ
    data() {
      return {

      }
    },
    computed: {
    	getStyle: function() {

    	  var resultStyle = ''

    	  var strPre = "background-image: url('"
    	  var strPost = "');"

    	  if(this.$store.state.commonUserInfo.hmpg != '') {
    	    resultStyle =  strPre + this.$store.state.commonUserInfo.hmpg + strPost
    	  }

    	  return resultStyle
    	}
    },
    methods: {
      // トップ画面へ戻る
      onToTop: function () {
        UtilityConsoleLog.consoleLog('CommonConfirmCancel::onBack Start') 

				// URLパラム
				var tempParam = this.$store.getters.getCommonParam

        // トップ画面へ遷移
        this.$router.push('/CommonTop/' + tempParam)

        UtilityConsoleLog.consoleLog('CommonConfirmCancel::onBack End')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/ForgetPassword/CommonForgetPassword2.vue